module.exports = __webpack_public_path__ + "static/media/open-sans-v17-latin_cyrillic-regular.18c55bb8.svg";